module.exports = __webpack_public_path__ + "img/020-windsurfing.07b6cd42.svg";